import { deserialize, identifier, serializable } from "serializr";
import { IJsonObject } from "../api";

interface IProps {
	id?: number | null;
	title?: string;
	completed?: boolean;
}

export class ProjectTaskChecklistItem {
	public static fromJson(json: IJsonObject): ProjectTaskChecklistItem {
		return deserialize(ProjectTaskChecklistItem, json);
	}

	public static fromJsonArray(
		json: IJsonObject[],
	): ProjectTaskChecklistItem[] {
		return json.map((task: IJsonObject) => this.fromJson(task));
	}

	@serializable(identifier())
	public id: number | null;

	@serializable
	public title: string | null;

	@serializable
	public completed: boolean | null;

	constructor({ id = null, title = "", completed = false }: IProps = {}) {
		this.id = id;
		this.title = title;
		this.completed = completed;
	}
}
